<template>
    <div class="pp-apartment-buildings-component pp-type-component">
        <div class="section-loading-screen" v-if="showLoading">
            <div class="section-loading-bubbles">
                <span class="d1"></span>
                <span class="d2"></span>
                <span class="d3"></span>
                <span class="d4"></span>
            </div>
        </div>
        <div class="pdetail-elements-group">
            <ul class="checkboxes-list">
                <li class="text-placeholder-radio" v-for="(building, key) in buildings" :key="key" :class="(building.total_items > 0 && building.total_items === building.items_sold) ? 'bloc-sold' : ''">
                    <input type="radio" :id="`buildingApartmentsPanelblockId${building.id}`"
                           name="buildingApartmentsRadio" v-model="selectedBuilding" :value="building.id"
                           class="text-checkbox-input" @change="setBuildingsFilter(building)">
                    <label :for="`buildingApartmentsPanelblockId${building.id}`" class="radio-input-placeholder">
                        <span> 
                          <span>Bloc {{ building.name }}</span>
                          <span>{{ building.finalized_date }}</span>
                        </span>
                    </label>
                    <span class="text-checkbox-counter">
                        {{ building.items_count }}
                    </span>
                </li>
            </ul>
        </div>
        <h2 class="pp-tab-heading" v-if="buildings.length > 0 && selectedBuilding">
          Toate apartamentele din blocul {{ buildings.find(building => building.id === selectedBuilding).name }}
          <span class="font-weight-normal">
            &bull;
          </span>
          <span class="font-weight-normal inline-block">
            Termen de finalizare {{ buildings.find(building => building.id === selectedBuilding).finalized_date }}
          </span>
          <span class="font-weight-normal">
            &bull;
          </span>
          <span class="font-weight-normal inline-block">
            {{ buildingData.availables }}
            {{ buildingData.availables !== 1 ? 'oferte disponibile' : 'oferta disponibila' }}
          </span>
        </h2>
        <div class="pdetail-levels-container levels-container pp-left-levels-container" :key="levelsKey">
            <div class="single-level-wrapper"  v-for="(level, key) in buildingData.levels" :key="key">
                <h3 class="collapse-trigger" data-toggle="collapse" :data-target="`#floortarget-${key}`" aria-expanded="false" :aria-controls="`floortarget-${key}`">
                     {{ level.name }}
                    <i class="fad fa-arrow-alt-circle-up"></i>
                 </h3>
                <div class="collapse-list collapse multi-collapse show" :id="`floortarget-${key}`">
                    <div class="single-level-row pdetail-level-row"  v-for="(item, key) in level.items" :key="key"
                         :class="item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available'"
                    >
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                <div class="level-item-nr level-strip-cell">
                                    <p
                                      @click="openModelDetailModal(projectId, item.model.id, 'apartments')"
                                      class="pp-blc-name c-pointer highlighted-info-strip"
                                    >
                                        <i class="fal fa-external-link"></i>
                                        {{ item.model.rooms_count ? item.model.rooms_count.name : '' }} tip {{ item.model.model_type }}
                                    </p>
                                </div>
                                <div class="level-item-size level-strip-cell ap-nr">
                                    <p class="level-cell-heading"> Ap. Nr: {{ item.apartment_number }}</p>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Suprafata </p>
                                    <div class="level-item-size level-strip-cell pdetail-level-cell surface-list">
                                        <p class="pdetail-surface-type">
                                            <span> Totala: </span>
                                            <span> {{ item.useful_surface }} m² </span>
                                        </p>
                                        <p class="pdetail-surface-type" v-if="item.terrace_surface">
                                            <span> Balcon: </span>
                                            <span> {{ item.terrace_surface }} m² </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret</p>
                                    <div class="prices-list">
                                        <p class="highlighted-info-strip" v-if="item.status !== 'available'"> -- </p>
                                        <p class="highlighted-info-strip" v-else>
                                          {{ formatPrice(item.price) }}
                                          <br>
                                          <small>({{item.price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret cu credit</p>
                                    <div class="prices-list">
                                        <p class="highlighted-info-strip" v-if="item.status !== 'available' || !item.credit_price"> -- </p>
                                        <p class="highlighted-info-strip" v-else>
                                          {{ formatPrice(item.credit_price) }}
                                          <br>
                                          <small>({{item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-auto col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Status</p>
                                    <p class="highlighted-info-strip"> {{ item.status
                                        === "available" ? "Disponibil" : "Vandut"
                                        }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PublicProjectApartmentBuildings",
    props: ['projectId','isAgent'],
    components: {
      // editor
    },
    data() {
      return {
        showLoading: false,
        levels: [],
        roomsCountFilter: [],
        selectedBuilding: null,
        selectedBuildingObject: null,
        buildings: [],
        levelsKey: 1
      }
    },
    async mounted() {
      this.showLoading = true;
      await this.getBuildingsData();
    },
    computed: {
      buildingData() {
        let output = {
          levels: [],
          availables: 0
        }
        for (let i in this.levels) {
          if (this.levels[i].items.length > 0) {
            this.levels[i].items.forEach(item => {
              if (item.status === 'available') output.availables++
            });
            output.levels.push(this.levels[i])
          }
        }
        output.levels.sort(function(a, b) { return a.sort_order - b.sort_order});
        return output;
      },
    },
    methods: {
      setBuildingsFilter(building) {
        let vm = this
        vm.selectedBuildingObject = building
        this.showLoading = true
        this.levels = building.levels
        for (let i in this.levels) {
          this.levels[i].items = building.items.filter(item => item.level_id === this.levels[i].id)
        }
        setTimeout(function(){ vm.showLoading = false }, 500);
      },
      getBuildingsData() {
        let vm = this
        this.showLoading = true;
        window.axios.get(`/ajax/get-buildings-by-model-type-with-items/${this.projectId}/apartment`)
          .then(function (resp) {
            vm.buildings = resp.data.data
            if (vm.buildings.length > 0) {
              let selected = null
              if (vm.selectedBuilding) {
                selected = vm.buildings.find(b => b.id === vm.selectedBuilding.id)
              }
              vm.selectedBuilding = selected ? selected.id : vm.buildings[0].id
              vm.selectedBuildingObject = selected ? selected : vm.buildings[0]
              vm.setBuildingsFilter(vm.selectedBuildingObject)
              vm.levelsKey++
            }
            vm.showLoading = false;
          })
          .catch(function () {
            vm.showLoading = false;
          });
      }
    }
  }
</script>
